<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.deal_create"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    (click)="createDeal()"
    sbTooltip="{{ 'lang.globals.createDeal' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>
</ng-container>

<!------------------------------

      Table-Wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.globals.deals' | translate}}"
  [itemsData]="deals"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'deals'">

  <!------------------------------

  Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >

      <sb-filter-section *ngPermissions="permissionService.Permission.ssp_contract_list"
                         title="{{'lang.globals.sspContracts' | translate}}"
                         icon="contract">
        <sb-filter-dto-list-select filterID="sspContracts" [endpoint]="api.shared_SSPContract_retrieveAll.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>

    </sb-filter-panel>
  </div>

  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>{{ 'lang.globals.identifier' | translate }}</th>
      <th>{{ 'lang.globals.name' | translate }}</th>
      <th>{{ 'lang.globals.sspContract' | translate }}</th>
      <th>{{ 'lang.globals.created' | translate }}</th>
      <th class=" sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

      Table Body

------------------------------->
  <ng-template #tbody let-deal>
    <tr>
      <td [inline]="true"
          *ngIf="discussionService.showRibbon || discussionService.showDiscussionSideBar"
          class="sticky-col discussion-col first-col tableBg" sb-discussion [inTable]="true"
          [entityElement]="{type: discussionService.DISCUSSABLES.Deal, element: deal}">
      </td>
      <td>
        {{ deal?.identifier }}
      </td>
      <td>
        {{ deal?.name }}
      </td>
      <td>
        <sb-comp-image-name-wrapper [image]="deal?.sspContract?.ssp?.primaryCompany?.logo?.url">
          <span
            firstLine>{{ deal?.sspContract?.name }} {{ deal?.sspContract?.identifier ? '(' + deal?.sspContract?.identifier + ')' : '' }}</span>
          <span secondLine>{{ deal?.sspContract?.ssp?.name }}</span>
        </sb-comp-image-name-wrapper>
      </td>
      <td>
        <sb-comp-display-created [data]="deal"></sb-comp-display-created>
      </td>
      <td class="sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="deal.sbButtons ?? []"
          (selectedAction)="resolveSplitButtonAction(deal, $event)"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>
</sb-table-wrapper-new>
